export default __webpack_public_path__ + "static/media/daisyGirl.e9e3a920.jpg";